import { render, staticRenderFns } from "./ConfigTextToSpeechForm.vue?vue&type=template&id=2d83f050"
import script from "./ConfigTextToSpeechForm.vue?vue&type=script&lang=js"
export * from "./ConfigTextToSpeechForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports